import React, { FC, useEffect, useState } from "react"
import { Footer as FooterComponent } from "@bancacfplus/Footer"
import BancoPosteLogo from "./assets/logo-banco-posta-businesslinkonline.svg?react"
import PosteItalianeLogo from "./assets/logo_posteitaliane-noBG.svg?react"
import { useGenerateCobrowseCode } from "../Cobrowse/hooks/useGenerateCobrowseCode"
import { CobrowseModal } from "../Cobrowse"
import { spellOutForScreenReader } from "../../utils/spellOutForScreenReader"
import style from "./Footer.module.scss"

export const Footer: FC<{ isPartnerPoste: boolean }> = ({ isPartnerPoste }) => {
  const [assistanceCode, setAssistanceCode] = useState<string | null>(null)
  const { loading, error, code, generate } = useGenerateCobrowseCode()

  useEffect(() => {
    if (code) {
      setAssistanceCode(code)
    }
  }, [code])

  return (
    <>
      <FooterComponent>
        {isPartnerPoste ? (
          <FooterComponent.Logo>
            <BancoPosteLogo aria-label="Logo BancoPoste" />
            <PosteItalianeLogo aria-label="Logo Poste Italiane" />
          </FooterComponent.Logo>
        ) : (
          <FooterComponent.Logo />
        )}
        <FooterComponent.Links title={""}>
          <a href="https://www.bancacfplus.it/legal-disclaimer/" target="_blank" rel="noreferrer">
            Note Legali
          </a>
        </FooterComponent.Links>
        <FooterComponent.Links title={""}>
          <a href="https://www.bancacfplus.it/privacy-policy/" target="_blank" rel="noreferrer">
            Privacy
          </a>
        </FooterComponent.Links>
        <FooterComponent.Links title={""}>
          <button className={style.action} onClick={generate}>
            Supporto clienti
          </button>
        </FooterComponent.Links>
        <FooterComponent.Links title={""}>
          <a href={"/privacy"}>Gestione consensi</a>
        </FooterComponent.Links>
        <FooterComponent.Links title={""}>
          <a href="mailto:customer.banking@bancacfplus.it">customer.banking@bancacfplus.it</a>
        </FooterComponent.Links>
        <FooterComponent.Copy>
          <p>
            Banca CF+ S.p.A. Via Piemonte, 38 – 00187 Roma | P. IVA{" "}
            <span aria-label={`Partita IVA ${spellOutForScreenReader("16340351002")}`}>16340351002</span> Copyright 2021
            - All Right Reserved
          </p>
        </FooterComponent.Copy>
      </FooterComponent>
      <CobrowseModal
        code={assistanceCode}
        closeHandler={setAssistanceCode}
        loading={loading}
        error={error}
        generateCode={generate}
      />
    </>
  )
}

export default Footer
